import { FC, PropsWithChildren } from 'react'
import { ActionProps, Title } from './Title.tsx'

type ContainerProps = {
    title?: string
    action?: ActionProps
    open?: boolean
}

export const Container: FC<PropsWithChildren<ContainerProps>> = ({ title, action, open = true, children }) => {
    return (
        <div>
            <Title title={title} action={action} />
            <div hidden={!open || !children}>
                <div className={'flex flex-col space-y-2'}>{children}</div>
            </div>
        </div>
    )
}
